$(document).ready(function () {
    const enabled_routes = [
        'contracts.index'
    ];

    if (!enabled_routes.includes(route().current())) {
        return;
    }

    const $contacts_modal = $('#call-contacts-modal')

    $(document).on('click', '.call-contacts', function () {

        let $contract_id = $(this).attr('data-id');

        $contacts_modal.find('.modal-body').load(route('contracts.show', $contract_id), function () {
            $contacts_modal.modal({show: true});
        })
    });
});
